import { emitHypotheticalEvent, emitHypotheticalEventWithMergeId } from "./eventEmitter";

const track = (hypotheticalTracking, eventMergeId) => {
    if (eventMergeId) {
        emitHypotheticalEventWithMergeId({ promo_RecoWhatIf: [hypotheticalTracking] }, eventMergeId);
    } else {
        emitHypotheticalEvent({ promo_RecoWhatIf: [hypotheticalTracking] });
    }
};

export default track;
